import type { Tagged } from 'type-fest';
import { UniqueShortId } from '../../common/id';

const uuidGenerator = UniqueShortId.GetFactory(18);

export namespace IdentityClusterMembership {
  export type Id = Tagged<UniqueShortId, 'identityClusterMembershipId'>;
  export namespace Id {
    export const Generate = () => uuidGenerator.generate() as Id;
    export function FromString(id: string): Id {
      return uuidGenerator.FromString(id) as Id;
    }
  }
}
